/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.vipSansAdresse.ts
 *
 * Invités VIP SANS adresse (2026-10-08, Mika : « crée les comptes même sans
 * adresse, on a besoin des badges » et « je dois voir ceux qui ont une
 * adresse et ceux qui n'en ont pas »). Fusionné dans fr.ts.
 * Aucun tiret cadratin, apostrophe typographique.
 *
 * Mikael - chef de projet - 2026-10-08
 */
export const messagesVipSansAdresseFr: Record<string, string> = {
  'vipAdmin.adresse.filtre': 'Adresse e-mail',
  'vipAdmin.adresse.tous': 'Toutes ({n})',
  'vipAdmin.adresse.avec': 'Avec adresse ({n})',
  'vipAdmin.adresse.sans': 'Sans adresse ({n})',
  'vipAdmin.kpi.sansAdresse': 'Sans adresse',
  'vipAdmin.sansAdresse': 'Sans adresse',
  'vipAdmin.sansAdresse.aide': 'Badge seulement : aucun accès à l’application tant qu’aucune adresse n’est enregistrée.',
  'vipAdmin.adresse.ajouter': 'Adresse e-mail de {nom}',
  'vipAdmin.adresse.enregistrer': 'Enregistrer l’adresse',
  'vipAdmin.adresse.enregistree': 'Adresse enregistrée pour {nom}. Aucun courriel n’est parti : utilisez « Envoyer l’invitation » quand vous êtes prêt.',
  'vipAdmin.envoyerInvitation': 'Envoyer l’invitation',
  'vipAdmin.creerSansAdresse': 'Créer le badge, sans courriel',
  'vipAdmin.creeSansAdresse': 'Invité créé sans adresse : son badge est disponible dans « Badges en lot », profil VIP.',
  'vipAdmin.creerAide': 'Sans adresse e-mail, l’invité est créé pour son badge seulement, rien n’est envoyé.',
  'vipAdmin.supprimer': 'Supprimer définitivement',
  'vipAdmin.supprimerConfirm':
    '{nom} va être archivé, puis vous pourrez le supprimer définitivement (super administrateur seulement), avec son accompagnant s’il en a un. Continuer ?',
  'vipAdmin.accompagnantDe': 'Accompagnant de {nom}',
  'vipAdmin.envoyerConfirm': 'Envoyer maintenant l’invitation à {nom} ?',
};
